import request from "@/config/utils/request";
import { addUrlPerFix } from "@/basa/utils";

//宣传海报
export function queryLscpPortalList(data) {
  return request({
    url: "/apis/jrw/common/users/signup/queryLscpPortalList",
    method: "post",
    data
  });
}

//轮播图点击量统计
export function updateHits(data) {
  return request({
    url: "/apis/pp/spcms/users/signup/cmc/pubcontent/updateHits",
    method: "post",
    data
  });
}

// 查询最新采购公告   /apis/jrw/common/users/signup/qryNoticePageList
export function qryNoticePageList(data) {
  return request({
    url: "/apis/jrw/common/users/signup/qryNoticePageList",
    method: "post",
    data
  });
}

//OAuth2.0
export function OAuth(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASEP_URL) +
      "/apis/basap/esi/login/iccec ",
    method: "post",
    data
  });
}

//外部系统获取商旅登录地址
export function getBusiTravelUrl(data) {
  return request({
    url: "/apis/jrw/getBusiTravelUrl",
    method: "post",
    data
  });
}

//通知公告
export function queryPublishedNoticeList(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_SP_URL) +
      "/apis/sp/spcms/users/signup/cmc/noticeInfo/queryPublishedNoticeList",
    method: "post",
    data
  });
}

// 右侧悬浮购物车数量
export function cartNum(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_EMP_URL) +
      "/apis/ccem/emc/users/signup/cartNum",
    method: "post",
    data
  });
}

// 右侧悬 发布需求
export function showFlag(data) {
  return request({
    url: addUrlPerFix(process.env.VUE_APP_EMP_URL) + "/apis/ccem/spc/showFlag",
    method: "post",
    data
  });
}
// 频道
export function qrySubTypeInfoList(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASE_URL) +
      "/apis/jrw/common/users/signup/qrySubTypeInfoList",
    method: "post",
    data
  });
}
// 通知
export function qryNoticeInfoPageList(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASE_URL) +
      "/apis/jrw/common/users/signup/qryNoticeInfoPageList",
    method: "post",
    data
  });
}
// 海报
export function qryAdvInfoList(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASE_URL) +
      "/apis/jrw/common/users/signup/qryAdvInfoList",
    method: "post",
    data
  });
}
// 通知详情
export function qryNoticeInfoDetails(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASE_URL) +
      "/apis/jrw/common/users/signup/qryNoticeInfoDetails",
    method: "post",
    data
  });
}
// 通知点击量
export function updateNoticeHits(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASE_URL) +
      "/apis/jrw/common/users/signup/updateNoticeHits",
    method: "post",
    data
  });
}
// 海报点击量
export function updateAdvHits(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASE_URL) +
      "/apis/jrw/common/users/signup/updateAdvHits",
    method: "post",
    data
  });
}
